/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    authMainLayoutContainer: {
      display: 'flex',
      height: '100%',
      overflow: 'auto',
    },
    authMainLayoutDetails: {
      flex: 1,
      position: 'relative',
    },
    authMainLayoutForm: {
      backgroundColor: theme.palette.secondary.light,
      flex: `0 0 ${theme.spacing(60)}px`,
      maxWidth: theme.spacing(60),
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    authMainLayoutFormContent: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    authMainLayoutFormMobile: {
      flex: `0 0 100%`,
      maxWidth: '100%',
    },
    authMainLayoutDetailsCont: {
      padding: theme.spacing(3),
      marginTop: '10%',
      marginLeft: '10%',
      maxWidth: theme.spacing(60),
    },
    logoWrap: {
      marginBottom: theme.spacing(3),
      width: theme.spacing(40),
    },
    logoImage: {
      width: 'inherit',
    },
    authBgImg: {
      backgroundImage: 'url(/images/idevp-login.svg)',
      position: 'absolute',
      right: 0,
      bottom: '5%',
      width: '60%',
      height: '60%',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right bottom',
      zIndex: -1,
    },
    descList: {
      listStyleType: 'disc',
      marginTop: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    descListItem: {
      display: 'list-item',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  })
);
